import type { FunctionComponent } from "react";
import { WalletTransactionsHeaderAdminPartial } from "../../../partials/admin/wallet-transactions/wallet-transactions-header.admin.partials";
import { Outlet } from "react-router-dom";

export const WalletTransactionsBaseAdminScreen: FunctionComponent = () => {
	return (
		<div className="relative min-h-svh h-svh flex flex-col flex-1">
			<WalletTransactionsHeaderAdminPartial />
			<Outlet />
		</div>
	);
};
